import React, { createContext, useContext, useState } from "react";

const InsightsContext = createContext({});

export const InsightsProvider = ({ children }) => {
    const [drawingOpen, setDrawingOpen] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [versionHistoryOpen, setVersionHistoryOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [isActivateInsightsModalOpen, setIsActivateInsightsModalOpen] = useState(false);

    return (
        <InsightsContext.Provider
            value={{
                drawingOpen,
                setDrawingOpen,
                settingsOpen,
                setSettingsOpen,
                versionHistoryOpen,
                setVersionHistoryOpen,
                submitting,
                setSubmitting,
                isActivateInsightsModalOpen,
                setIsActivateInsightsModalOpen,
            }}
        >
            {children}
        </InsightsContext.Provider>
    );
};

export const useInsights = () => useContext(InsightsContext);
